import { ComponentProps, FC } from "react";
import { twCn } from "@/styles/utils";

export type CardBlankProps = ComponentProps<"div">;

export const CardBlank: FC<CardBlankProps> = ({
  className,
  onClick,
  ...props
}) => {
  return (
    <div
      {...props}
      className={twCn(
        "rounded-2xl bg-[var(--light-color)] p-4 shadow-[var(--component-shadow)]",
        className,
      )}
      onClick={onClick}
    />
  );
};
